export function sanitizeNumber(input) {
  return input && !isNaN(input) ? Number(input) : 0;
}

export function isMobileDevice() {
  this.windowDimensions = {
    height: window.innerHeight,
    width: window.innerWidth
  };
  if (this.windowDimensions.width <= 915) return true;
  else return isMobileOs();
}

function isMobileOs() {
  //Storing user's device details in a variable
  let details = navigator.userAgent;

  //Creating a regular expression containing some mobile devices keywords to search it in details string
  let regexp = /android|iphone|kindle|ipad/i;

  //Using test() method to search regexp in details it returns boolean value
  return regexp.test(details);

  //check window orientation, if -1 desktop
  //depreciated method
  //return window.orientation > -1;
}

export function secondsToTimeForDisplay(sec_num = 0) {
  let hours = Math.floor(sec_num / 3600);
  if (hours < 0) hours = 0;

  let minutes = Math.floor((sec_num - hours * 3600) / 60);
  if (minutes < 0) minutes = 0;

  let seconds = sec_num - hours * 3600 - minutes * 60;
  if (seconds < 0) seconds = 0;

  let hoursDisp = '00',
    minutesDisp = '00',
    secondsDips = '00';

  if (hours < 10) hoursDisp = '0' + hours;
  else hoursDisp = hours.toString();

  if (minutes < 10) minutesDisp = '0' + minutes;
  else minutesDisp = minutes.toString();

  if (seconds < 10) secondsDips = '0' + seconds;
  else secondsDips = seconds.toString();

  return `${hoursDisp}:${minutesDisp}:${secondsDips}`;
}

export function validateEmail(email) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) return true;
  else return false;
}

export function isNumeric(str) {
  if (typeof str != 'string') return false;

  return /^\d+$/.test(str);
}

const menuDef = [
  // { id: 'account', name: 'Account Details', icon: 'account_circle', requiresAuth: true, empl: false, descr: 'AccountDetailsDescr' },
  // {id: 'financial',name: 'Financial Transaction Details',icon: 'monetization_on',requiresAuth: true,empl: false,descr: 'FinancialTransactionDetailsDescr'},
  // { id: 'readings', name: 'Meter Readings', icon: 'timeline', requiresAuth: true, empl: false, descr: 'MeterReadingsDescr' },
  // { id: 'apps', name: 'Applications', icon: 'contact_mail', requiresAuth: true, empl: false, descr: 'ApplicationsDescr' },
  // { id: 'billPayment', name: 'Bill Payment', icon: 'payment', requiresAuth: true, empl: false, descr: 'BillPaymentDescr' },

  // // employee
  { id: 'employeeHome', name: 'Home page', icon: 'home', requiresAuth: true, empl: true, descr: '' },

  // { id: 'enquiries', name: 'Enquiries', icon: 'search', requiresAuth: true, empl: true, descr: 'EnquiriesDescr' },

  // { id: 'dmControlPanel', name: 'DmContolPanel', icon: 'add_card', requiresAuth: true, empl: true, descr: 'DmContolPanelDescr' },

  // { id: 'conditionAssessment', name: 'ConditionAssessment', icon: 'business', requiresAuth: true, empl: true, descr: 'ConditionAssessmentSubtitle' },
  // { id: 'logs', name: 'Logs', icon: 'assignment', requiresAuth: true, empl: true, descr: 'LogsDescr' },

  // { id: 'agreements', name: 'Agreements', icon: 'handshake', requiresAuth: true, empl: true, descr: 'AgreementsDescr' },

  // { id: 'captureMeterReadings', name: 'CaptureMeterReadings', icon: 'gas_meter', requiresAuth: true, empl: true, descr: 'CaptureMeterReadingsDescr' },
  // { id: 'cmrAdmin', name: 'cmrAdmin', icon: 'gas_meter', requiresAuth: true, empl: true, descr: 'cmrAdminDescr' },
  // { id: 'webgis', name: 'GIS', icon: 'map', requiresAuth: true, empl: true, descr: 'GISDescr' },
  // { id: 'gisAdministration', name: 'GIS Administration', icon: 'settings', requiresAuth: true, empl: true, descr: 'GISAdministrationDescr' },
  // { id: 'billing', name: 'billingModule', icon: 'point_of_sale', requiresAuth: true, empl: true, descr: 'billingModuleDescr' },
  // { id: 'receipting', name: 'Receipting', icon: 'receipt', requiresAuth: true, empl: true, descr: 'ReceiptingDescr' },

  { id: 'sessions', name: 'Sessions', icon: 'receipt_long', requiresAuth: true, empl: true, descr: 'SessionsDescr' },
  { id: 'assets', name: 'Assets', icon: 'extension', requiresAuth: true, empl: true, descr: 'AssetsDescr' },
  { id: 'samples', name: 'Samples', icon: 'format_color_fill', requiresAuth: true, empl: true, descr: 'SamplesDescr' },
  { id: 'omApplications', name: 'OmApplications', icon: 'perm_data_setting', requiresAuth: true, empl: true, descr: 'OmApplicationsDescr' },
  { id: 'omActivities', name: 'OmActivities', icon: 'app_settings_alt', requiresAuth: true, empl: true, descr: 'OmActivitiesDescr' },
  { id: 'applications', name: 'Applications', icon: 'contact_mail', requiresAuth: true, empl: true, descr: 'EmployeeApplicationsDescr' },
  { id: 'disconnections', name: 'Disconnections', icon: 'format_color_reset', requiresAuth: true, empl: true, descr: 'DisconnectionsDescr' },
  { id: 'dm', name: 'Dm', icon: 'credit_card', requiresAuth: true, empl: true, descr: 'DmDescr' },

];

export function getMenuItems(user, roles) {
  var menu = menuDef;
  if (user && user.authenticated) {
    if (user.role == roles.Employee)
      return menu.filter(function (item) {
        return item.empl;
      });
    else
      return menu.filter(function (item) {
        return !item.empl;
      });
  } else
    return menu.filter(function (item) {
      return !item.requiresAuth;
    });
}

export function capitalizeFirstLetter(str) {
  if (!str) return;
  else return String(str).charAt(0).toUpperCase() + String(str).slice(1);
}

export function getOfflinePagingOptions(page = 0, pageSize = 0, total = 0) {
  let end = pageSize * page;
  let start = end - pageSize;

  if (end > total) end = total;

  if (start > total) start = total;

  if (start < 0) start = 0;

  return [start, end];
}
